import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthTokenService } from './auth-token.service';

/**
 * Gate a route behind guest login. Waits for the initial Firebase auth state to
 * resolve (so a returning guest isn't bounced to /login on reload), then either
 * allows the route or redirects to /login carrying a `returnUrl` so checkout can
 * resume exactly where it left off.
 */
export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthTokenService);
  const router = inject(Router);

  await auth.whenReady();
  if (auth.isAuthenticated()) {
    return true;
  }
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url },
  });
};
